import { extractHostname } from '@civilgrid/ui/utils';
import { captureTypedPosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import type { SidebarFieldRow, SidebarSection } from './buildSidebarSections';

interface MetadataSidebarAnalyticsContext {
  projectId?: string;
  organizationId?: string | null;
}

/** Fires when a URL attribute row opens its external record; omits `project_id` on the non-project map. */
export function captureMetadataLinkOpened(
  ctx: MetadataSidebarAnalyticsContext,
  section: SidebarSection,
  row: SidebarFieldRow,
): void {
  captureTypedPosthogEvent(POSTHOG_EVENTS.mapMetadataLinkOpened, {
    ...(ctx.projectId && { project_id: ctx.projectId }),
    organization_id: ctx.organizationId || undefined,
    layer_id: section.layerId,
    field_label: row.label,
    url_host: extractHostname(row.value) ?? '',
  });
}
